import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

function initWhatsAppCartButton() {
  const btn = document.querySelector("#whatsapp-cart-btn");
  if (!btn || btn.dataset.bound === "true") return;
  btn.dataset.bound = "true";

  btn.addEventListener("click", async (e) => {
    e.preventDefault();
    const phone = "447476605569";

    try {
      const cart = await fetch("/cart.js").then(r => r.json());
      if (!cart.items || cart.items.length === 0) {
        alert("Your cart is empty!");
        return;
      }

      let message = "🛒 *New Order Request*\n\n";
      cart.items.forEach((item, i) => {
        message += `*${i + 1}. ${item.product_title}*\n`;
        if (item.variant_title && item.variant_title !== "Default Title") {
          message += `Variant: ${item.variant_title}\n`;
        }
        message += `Qty: ${item.quantity}\n`;
        message += `Price: $${(item.final_line_price / 100).toFixed(2)}\n`;
        message += `Product Link: ${window.location.origin}${item.url}\n\n`;
      });

      const subtotalUSD = (cart.items_subtotal_price / 100).toFixed(2);
      message += `*Subtotal:* $${subtotalUSD}\n`;
      const totalDiscountUSD = ((cart.items_subtotal_price - cart.total_price) / 100).toFixed(2);
      if (totalDiscountUSD > 0) {
        message += `*Discount:* -$${totalDiscountUSD}\n`;
      }
      const finalTotalUSD = (cart.total_price / 100).toFixed(2);
      message += `*Total:* $${finalTotalUSD}\n\n`;
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        message += "*Discount Code(s) Applied:* " + cart.discount_codes.map(d => d.code).join(", ") + "\n";
      }
      message += "\nPlease confirm my order ✅";

      const url = "https://wa.me/" + phone + "?text=" + encodeURIComponent(message);

      // Cross-browser open
      const ua = navigator.userAgent;
      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

      if (isIOS || isSafari) {
        // iOS Safari / Safari: direct navigation
        window.location.href = url;
      } else {
        // Desktop / Android: new tab
        const newWin = window.open(url, "_blank");
        if (!newWin) {
          // Popup blocked fallback
          alert("Please allow popups to open WhatsApp.");
        }
      }

    } catch (err) {
      console.error("WhatsApp order error:", err);
      alert("WhatsApp order failed. please try again !");
    }
  });
}

/* =========================
   Cart Drawer Component
========================= */
class CartDrawerComponent extends DialogComponent {
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#onOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#onOpen);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  #onOpen = () => {
    setTimeout(initWhatsAppCartButton, 300);
    this.#updateStickyState();

    const escHandler = (e) => {
      if (e.key === "Escape") this.closeDialog();
    };
    document.addEventListener("keydown", escHandler);
    const removeEsc = () => {
      document.removeEventListener("keydown", escHandler);
      this.removeEventListener('dialog-close', removeEsc);
    };
    this.addEventListener('dialog-close', removeEsc);
  };

  #updateStickyState = () => {
    const dialog = this.refs?.dialog;
    if (!dialog) return;
    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');
    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }
    const ratio = summary.getBoundingClientRect().height / dialog.getBoundingClientRect().height;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  };
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
